import { Box, Paper, Stack } from "@mui/material";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import adpClearLogo from "../../img/adpclear-updated-logo.png";
import { ReactElement, ReactNode } from "react";

export const LoginPageWrapper = (props: {
  children: ReactNode | ReactElement | ReactElement[];
  spacing?: number;
  showReturnButton?: boolean;
  onReturnChange?: () => void;
}) => {
  const { children, spacing = 2, showReturnButton, onReturnChange } = props;

  const logo = (
    <Box sx={{ m: "0 auto !important", pr: showReturnButton ? 3 : 0 }}>
      <img
        src={adpClearLogo}
        alt="logo"
        style={{
          height: `40px`,
        }}
      />
    </Box>
  );

  return (
    <Paper>
      <Stack sx={{ p: 4 }} spacing={spacing}>
        {showReturnButton ? (
          <Box
            sx={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
            }}
          >
            <ArrowBackIcon
              style={{ cursor: "pointer" }}
              onClick={onReturnChange}
            />
            {logo}
          </Box>
        ) : (
          logo
        )}
        <Stack>{children}</Stack>
      </Stack>
    </Paper>
  );
};
